function chooseMembershipsQuantity() {
    const $input = $('.js-quantity-field');
    const min = parseInt($input.data('min'), 10);
    const max = parseInt($input.data('max'), 10);

    setCost();

    function updateButtons() {
        const val = parseInt($input.val(), 10);
        $('.js-minus-btn').prop('disabled', val <= min);
        $('.js-plus-btn').prop('disabled', val >= max);
    }

    $('.js-plus-btn').on('click', function () {
        let currentVal = parseInt($input.val(), 10);
        if (!isNaN(currentVal) && currentVal < max) {
            $input.val(currentVal + 1).trigger('change');
        }
        updateButtons();
    });

    function setCost() {
        const costElem = $('.js-memberships-cost');
        const val = parseInt($input.val(), 10);
        if (multiplier && !isNaN(val)) {
            const total = multiplier * val;

            const formatted = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(total);
            costElem.text(formatted);
        }
    }

    $('.js-minus-btn').on('click', function () {
        let currentVal = parseInt($input.val(), 10);
        if (!isNaN(currentVal) && currentVal > min) {
            $input.val(currentVal - 1).trigger('change');
        }
        updateButtons();
    });

    $input.on('input', function () {
        let rawVal = $input.val();

        if (rawVal === '') {
            return;
        }

        const numVal = parseInt(rawVal, 10);

        if (!isNaN(numVal)) {
            if (numVal < min || numVal > max) {
                // Optional: show invalid state, but don’t clamp yet
            }
        }

        updateButtons();
        setCost();
    });

    $input.on('change blur', function () {
        let rawVal = $input.val();
        let numVal = parseInt(rawVal, 10);

        if (rawVal === '') {
            $input.val(min);
        } else if (!isNaN(numVal)) {
            if (numVal < min) {
                $input.val(min);
            } else if (numVal > max) {
                $input.val(max);
            }
        } else {
            $input.val(min);
        }

        updateButtons();
        setCost();
    });

    updateButtons();
}

runIfElementExist(chooseMembershipsQuantity, '.js-quantity-field');
